import { render, staticRenderFns } from "./opcoes.vue?vue&type=template&id=50ab346c&scoped=true&"
import script from "./opcoes.vue?vue&type=script&lang=js&"
export * from "./opcoes.vue?vue&type=script&lang=js&"
import style0 from "./opcoes.vue?vue&type=style&index=0&id=50ab346c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab346c",
  null
  
)

export default component.exports